import { Box, Grid } from '@material-ui/core';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DateRange } from '@mui/lab/DateRangePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import jaLocale from 'date-fns/locale/ja';
import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { API_URL, LICENSE } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';

const Corporate: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);

  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }

  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });


  /*id取得*/
  const { state } = useLocation();
  const id = (state as any)?.id;

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  console.log('jsonlist:', jsonlist)

  const [posts, setPosts] = useState({ company_name: "" })
  const [userPosts, setUserPosts] = useState([{ user_id: "" }])
  const [constructionPosts, setConstructionPosts] = useState([{ construction_id: "" }])


  const company_id = (posts as any)?.company_id;
  const company_name = (posts as any)?.company_name;
  const company_name_kana = (posts as any)?.company_name_kana;
  const contract_type = (posts as any)?.contract_type;
  const from_date = (posts as any)?.from_date;
  const to_date = (posts as any)?.to_date;
  const total_user_count = (posts as any)?.total_user_count;
  const total_capacity = (posts as any)?.total_capacity;
  const remarks = (posts as any)?.remarks;

  useEffect(() => {
    openLoading()
    axios.post(API_URL.COMPANY_GET,
      {
        "company_id": jsonlist.company.company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const company = res.data.data;
        setPosts(company)
        // console.log(posts)
      })
      .catch(error => {
        console.log(error)
        let jsonObject = JSON.parse(error);
      })
      .finally(() => {
        closeLoading()
      })

    console.log('company:', company_id)
    // 企業内ユーザー取得
    axios.post(API_URL.USER_LIST,
      {
        "company_id": jsonlist.company.company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },

    )
      .then(res => {
        const persons = res.data.data;
        setUserPosts(persons)

      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

    // 企業内工事取得
    axios.post(API_URL.CONSTRUCTION_LIST,
      {
        "company_id": jsonlist.company.company_id,
        "dealer_info_id": jsonlist.company.company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },

    )
      .then(res => {
        const construction = res.data.data;
        setConstructionPosts(construction)

      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }, []);


  // 適切な形式で容量を表示
  const capacity = ({ val }: { val: string }) => {
    const size = Number(val)
    const gb = 1024000000
    // 表示単位はGB固定とし、小数点第二位まで表示
    const capacity_val = Math.floor((size / gb) * 100) / 100
    return capacity_val + ' ' + 'GB'
  }

  // 利用停止文字列
  const active_state = ({ val }: { val: string }) => {
    if (val == "1") {
      return "利用可能"
    } else {
      return "利用停止中"
    }
  }

  // 工事データから利用容量を産出
  const sumFileSize = () => {
    let subtotal = 0
    constructionPosts.forEach(item => {
      let size = (item as any)?.storage_size
      if (!isNaN(size)) {
        subtotal += parseInt(size)
      }
    })
    return subtotal.toString()
  }

  // 画面表示
  return (
    <GenericTemplate title="契約情報">
      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}></Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} >
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業ID</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={company_id}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業名</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={company_name}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業名カナ</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={company_name_kana}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">契約形態</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={LICENSE[contract_type]}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">契約期間</Grid>
          <Grid item xs={10}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
              <MobileDateRangePicker
                startText="開始時期"
                endText="終了時期"
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <React.Fragment>
                    <TextField value={from_date} variant="standard" />
                    <Box sx={{ mx: 2 }}> 〜 </Box>
                    <TextField value={to_date} variant="standard" />
                  </React.Fragment>
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Stack>


      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">最大ユーザー数</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              variant="standard"
              className="small-text"
              inputProps={{ readOnly: true }}
              value={total_user_count}
            />
          </Grid>
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">利用ユーザー数</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              variant="standard"
              className="small-text"
              inputProps={{ readOnly: true }}
              value={userPosts.length}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">最大容量</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              variant="standard"
              className="small-text"
              inputProps={{ readOnly: true }}
              value={total_capacity + ' GB'}
            />
          </Grid>
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">利用容量</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              variant="standard"
              className="small-text"
              inputProps={{ readOnly: true }}
              value={capacity({ val: sumFileSize() })}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">備考</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              className="large-text"
              multiline
              variant="standard"
              inputProps={{ readOnly: true }}
              value={remarks}
            />
          </Grid>
        </Grid>
      </Stack>

    </GenericTemplate>
  );
};

export default Corporate;